import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { OrderNavigationPage } from './order-navigation';

@NgModule({
  declarations: [OrderNavigationPage],
  imports: [IonicPageModule.forChild(OrderNavigationPage)],
})
export class OrderNavigationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-navigation/order-navigation.module.ts